/*@jsxRuntime classic @jsx React.createElement @jsxFrag React.Fragment*/
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import React from "react";
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    a: "a"
  }, _provideComponents(), props.components);
  return React.createElement(_components.p, null, "Edited by FoAM members Mark Valentine and Timothy J.Jarvis, ", React.createElement(_components.a, {
    href: "https://www.hippocampuspress.com/other-authors/nonfiction/the-secret-ceremonies-critical-essays-on-arthur-machen"
  }, "this is a new publication by Hippocampus Press"), ". The book contains 20 essays on Machen's work, some with the authority of the past but many of them new and written for this publication. Also contains a selection of Machen's own reflections on his literary career.");
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? React.createElement(MDXLayout, props, React.createElement(_createMdxContent, props)) : _createMdxContent(props);
}
export default MDXContent;
